type regionConfigType = Record<
  string,
  {
    multiplePathologies: boolean;
    noDegree: boolean;
    requiredFields: string[];
  }
>;

const regionConfig: regionConfigType = {
  hip_joint: {
    multiplePathologies: false,
    noDegree: false,
    requiredFields: ["visiblePart", "mode", "projection"],
  },
  spine: {
    multiplePathologies: true,
    noDegree: true,
    requiredFields: ["visiblePart", "projection"],
  },
};

export default regionConfig;
